module.exports = __webpack_public_path__ + "img/tick.ea83b608.svg";